import { createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a771aea6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "nge-smo-mode-badge success-badge" }
const _hoisted_2 = { class: "nge-smo-hint success-hint" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-smo-swap-banner-step" }, "Red is placed", -1 /* HOISTED */))
const _hoisted_4 = {
  key: 0,
  class: "nge-smo-swap-banner-main"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "blue", -1 /* HOISTED */))
const _hoisted_6 = {
  key: 1,
  class: "nge-smo-swap-banner-main"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("kbd", null, "G", -1 /* HOISTED */))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "blue", -1 /* HOISTED */))
const _hoisted_9 = { class: "nge-smo-swap-banner-sub" }
const _hoisted_10 = {
  key: 1,
  class: "nge-smo-loading-indicator nge-smo-loading-indicator--left"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-smo-spinner" }, null, -1 /* HOISTED */))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-smo-mode-badge split-badge" }, " CUT MODE ", -1 /* HOISTED */))
const _hoisted_14 = ["title"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-smo-group-dot red-dot" }, null, -1 /* HOISTED */))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-smo-group-label" }, "RED", -1 /* HOISTED */))
const _hoisted_17 = { class: "nge-smo-group-count" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-smo-divider" }, "|", -1 /* HOISTED */))
const _hoisted_19 = ["title"]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-smo-group-dot blue-dot" }, null, -1 /* HOISTED */))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-smo-group-label" }, "BLUE", -1 /* HOISTED */))
const _hoisted_22 = { class: "nge-smo-group-count" }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = {
  key: 2,
  class: "nge-smo-actions nge-smo-actions--left"
}
const _hoisted_25 = ["disabled", "title"]
const _hoisted_26 = ["aria-checked"]
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 24 24",
  width: "16",
  height: "16",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M20 22 L11 4",
    stroke: "#fff",
    "stroke-width": "2.2",
    "stroke-linecap": "round",
    fill: "none"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M12 3 C7 1.5 2.5 5.5 1 13 C4.5 9 8.5 7.5 14 7 Z",
    fill: "#fff"
  })
], -1 /* HOISTED */))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-smo-reap-track" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "nge-smo-reap-knob" })
], -1 /* HOISTED */))
const _hoisted_29 = { key: 0 }
const _hoisted_30 = {
  key: 3,
  class: "nge-smo-stale",
  role: "status"
}
const _hoisted_31 = {
  class: "nge-smo-auto-submit nge-smo-point-size",
  title: "How big the red and blue cut points are drawn. Annotation layers keep their own size."
}
const _hoisted_32 = ["value"]
const _hoisted_33 = ["value"]
const _hoisted_34 = ["onClick"]
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-smo-mode-badge merge-badge" }, " MERGE MODE ", -1 /* HOISTED */))
const _hoisted_36 = {
  key: 0,
  class: "nge-smo-loading-indicator nge-smo-loading-indicator--left"
}
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-smo-spinner" }, null, -1 /* HOISTED */))
const _hoisted_38 = [
  _hoisted_37
]
const _hoisted_39 = {
  key: 1,
  class: "nge-smo-actions nge-smo-actions--left"
}
const _hoisted_40 = { key: 0 }
const _hoisted_41 = ["onClick"]
const _hoisted_42 = {
  key: 0,
  class: "nge-smo-key-hint"
}
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("kbd", null, "Ctrl+Click", -1 /* HOISTED */))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "▴", -1 /* HOISTED */))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "nge-smo-merge-grip",
  "aria-hidden": "true"
}, "⠿", -1 /* HOISTED */))
const _hoisted_46 = { class: "nge-smo-merge-panel-list" }
const _hoisted_47 = { class: "nge-smo-merge-num" }
const _hoisted_48 = ["onMouseenter", "onContextmenu"]
const _hoisted_49 = {
  key: 0,
  class: "nge-smo-merge-arrow"
}
const _hoisted_50 = ["onMouseenter", "onContextmenu"]
const _hoisted_51 = ["onClick"]
const _hoisted_52 = {
  key: 4,
  class: "nge-smo-merge-why"
}
const _hoisted_53 = { class: "nge-smo-result-icon" }
const _hoisted_54 = { class: "nge-smo-result-body" }
const _hoisted_55 = { class: "nge-smo-result-text" }
const _hoisted_56 = {
  key: 0,
  class: "nge-smo-result-actions"
}
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-smo-result-retry" }, "Press Enter to retry", -1 /* HOISTED */))
const _hoisted_58 = ["onClick"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, { name: "overlay-slide" }, {
      default: _withCtx(() => [
        ($setup.isVisible)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              ref: "barEl",
              class: _normalizeClass(["nge-split-merge-overlay", {
        'nge-smo-has-banner': $setup.needsSwap,
        'nge-smo-learning': $setup.inPracticeTutorial,
        multicut: $setup.isMulticut && !$setup.isPendingClose,
        'group-red': $setup.isMulticut && !$setup.isPendingClose && $setup.isRedActive,
        'group-blue': $setup.isMulticut && !$setup.isPendingClose && $setup.isBlueActive,
        merge: $setup.isMerge && !$setup.isPendingClose,
        submitting: $setup.isSubmitting,
        'bar-success': $setup.isPendingClose && $setup.resultIsSuccess,
        'bar-error': $setup.isPendingClose && $setup.resultIsError,
        'bar-inline-success': $setup.hasInlineResult && $setup.resultIsSuccess,
        'bar-inline-error': $setup.hasInlineResult && $setup.resultIsError,
      }])
            }, [
              _createCommentVNode(" SUCCESS / ERROR CLOSE STATE — replaces normal content "),
              ($setup.isPendingClose)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("div", _hoisted_1, _toDisplayString($setup.resultIsSuccess ? 'SUCCESS' : 'ERROR'), 1 /* TEXT */),
                    _createElementVNode("div", _hoisted_2, _toDisplayString($setup.store.resultText), 1 /* TEXT */)
                  ], 64 /* STABLE_FRAGMENT */))
                : ($setup.isMulticut)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createCommentVNode(" MULTICUT / SPLIT MODE "),
                      _createCommentVNode(" \"Press G\": red is placed, blue is empty, red is still on. A\n               large prompt above the bar, since the small key on the bar was\n               missed and second red points were placed instead (Ames,\n               2026-10-08). Clicking it switches too. "),
                      ($setup.needsSwap && $setup.inPracticeTutorial)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "nge-smo-swap-banner",
                            onClick: _cache[0] || (_cache[0] = $event => ($setup.swapGroup())),
                            role: "status"
                          }, [
                            _hoisted_3,
                            ($setup.isTouchRef)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                                  _createTextVNode("Now tap here to switch to "),
                                  _hoisted_5
                                ]))
                              : (_openBlock(), _createElementBlock("span", _hoisted_6, [
                                  _createTextVNode("Now press "),
                                  _hoisted_7,
                                  _createTextVNode(" to switch to "),
                                  _hoisted_8
                                ])),
                            _createElementVNode("span", _hoisted_9, _toDisplayString($setup.isTouchRef ? 'then tap the other side' : 'then Ctrl+click the other side'), 1 /* TEXT */)
                          ]))
                        : _createCommentVNode("v-if", true),
                      ($setup.isSubmitting)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_12))
                        : _createCommentVNode("v-if", true),
                      _hoisted_13,
                      _createElementVNode("div", {
                        class: _normalizeClass(["nge-smo-groups", { 'nge-smo-groups--pulse': $setup.groupPulse }])
                      }, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["nge-smo-group red", { active: $setup.isRedActive }]),
                          onClick: _cache[1] || (_cache[1] = $event => (!$setup.isRedActive && $setup.swapGroup())),
                          title: $setup.isRedActive ? 'Red group (active)' : 'Click to switch to Red'
                        }, [
                          _hoisted_15,
                          _hoisted_16,
                          _createElementVNode("span", _hoisted_17, _toDisplayString($setup.store.redPointCount) + " pt" + _toDisplayString($setup.store.redPointCount !== 1 ? 's' : ''), 1 /* TEXT */)
                        ], 10 /* CLASS, PROPS */, _hoisted_14),
                        _hoisted_18,
                        _createElementVNode("div", {
                          class: _normalizeClass(["nge-smo-group blue", { active: $setup.isBlueActive }]),
                          onClick: _cache[2] || (_cache[2] = $event => (!$setup.isBlueActive && $setup.swapGroup())),
                          title: $setup.isBlueActive ? 'Blue group (active)' : 'Click to switch to Blue'
                        }, [
                          _hoisted_20,
                          _hoisted_21,
                          _createElementVNode("span", _hoisted_22, _toDisplayString($setup.store.bluePointCount) + " pt" + _toDisplayString($setup.store.bluePointCount !== 1 ? 's' : ''), 1 /* TEXT */)
                        ], 10 /* CLASS, PROPS */, _hoisted_19),
                        _createCommentVNode(" The swap key sits with the colours it swaps (it used to be\n                 far right, among Submit and Cancel). "),
                        _createElementVNode("span", {
                          class: _normalizeClass(["nge-smo-key-hint nge-smo-swap-hint", { 'nge-smo-swap-hint--now': $setup.needsSwap, 'nge-smo-swap-hint--touch': $setup.isTouchRef }]),
                          onClick: _cache[3] || (_cache[3] = $event => ($setup.swapGroup())),
                          title: "Switch between red and blue"
                        }, [
                          (!$setup.isTouchRef)
                            ? (_openBlock(), _createElementBlock("kbd", _hoisted_23, "G"))
                            : _createCommentVNode("v-if", true),
                          _createTextVNode(" " + _toDisplayString($setup.needsSwap ? ($setup.isTouchRef ? 'Tap for blue' : 'Press G for blue') : 'Swap'), 1 /* TEXT */)
                        ], 2 /* CLASS */)
                      ], 2 /* CLASS */),
                      _createCommentVNode(" All the cut controls sit together on the left (Ames,\n               2026-10-07); the hint takes the rest of the bar. "),
                      (!$setup.isSubmitting)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                            _createElementVNode("button", {
                              class: _normalizeClass(["nge-smo-action-btn submit-btn", { 'is-ready': $setup.cutReady }]),
                              onClick: _cache[4] || (_cache[4] = $event => ($setup.submitTool('multicut'))),
                              title: "Submit the cut (or press Enter)"
                            }, "Submit cut", 2 /* CLASS */),
                            _createCommentVNode(" Shows where the cut would fall, before it is made (src/util/cut_preview.ts). "),
                            _createElementVNode("button", {
                              class: "nge-smo-action-btn clear-btn",
                              disabled: !$setup.cutReady || $setup.previewBusy,
                              onClick: $setup.previewCut,
                              title: $setup.cutReady ? 'Show in 3D, in red and blue, which side of the cut each part of the cell would fall on. Nothing is cut.' : 'Place a red and a blue point first'
                            }, _toDisplayString($setup.previewBusy ? 'Previewing…' : 'Preview'), 9 /* TEXT, PROPS */, _hoisted_25),
                            _createElementVNode("button", {
                              class: "nge-smo-action-btn clear-btn",
                              onClick: $setup.clearPoints,
                              title: "Clear all points"
                            }, "Clear"),
                            _createCommentVNode(" Clears a piece from view; never edits (src/util/scythe.ts). "),
                            (!$setup.tutorialOnScreen)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  type: "button",
                                  role: "switch",
                                  class: _normalizeClass(["nge-smo-reap", { 'is-on': $setup.reapAfterCut }]),
                                  "aria-checked": $setup.reapAfterCut,
                                  onClick: _cache[5] || (_cache[5] = $event => ($setup.setReapAfterCut(!$setup.reapAfterCut))),
                                  title: "On: after each cut, your next click on a piece in 3D reaps it from view, then the cursor goes back to normal. Ctrl+Z brings a piece back. Shift+R takes up the scythe any time."
                                }, [
                                  _hoisted_27,
                                  _createTextVNode(" Scythe reap "),
                                  _hoisted_28
                                ], 10 /* CLASS, PROPS */, _hoisted_26))
                              : _createCommentVNode("v-if", true),
                            _createElementVNode("button", {
                              class: "nge-smo-action-btn cancel-btn",
                              onClick: $setup.cancelTool,
                              title: "Exit cut mode"
                            }, [
                              (!$setup.isTouchRef)
                                ? (_openBlock(), _createElementBlock("kbd", _hoisted_29, "Esc"))
                                : _createCommentVNode("v-if", true),
                              _createTextVNode(" Cancel")
                            ])
                          ]))
                        : _createCommentVNode("v-if", true),
                      _createCommentVNode(" Points left on a cell that is not shown were cleared as cut\n               mode opened, so the player's own cells stay on screen\n               (util/stale_cut_points.ts). Undo puts them back. "),
                      ($setup.store.staleCutCleared)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                            _createElementVNode("span", null, "Cleared " + _toDisplayString($setup.store.staleCutCleared) + " point" + _toDisplayString($setup.store.staleCutCleared !== 1 ? 's' : '') + " left on another cell.", 1 /* TEXT */),
                            _createElementVNode("button", {
                              class: "nge-smo-action-btn nge-smo-stale-undo",
                              onClick: $setup.undoStaleClear,
                              title: "Put the points back. Cut mode then shows only their cell."
                            }, "Undo")
                          ]))
                        : (_openBlock(), _createElementBlock("div", {
                            key: 4,
                            class: _normalizeClass(["nge-smo-hint nge-smo-hint--left", { 'error-hint': $setup.hasInlineResult && $setup.resultIsError, 'nge-smo-hint--now': $setup.needsSwap }])
                          }, _toDisplayString($setup.contextHint), 3 /* TEXT, CLASS */)),
                      _createCommentVNode(" At the right end: whether the bar stays after a cut. Off by\n               default (Ames: one cut, then move on); on for a run of cuts on\n               one cell (Nseraf). "),
                      _createElementVNode("label", _hoisted_31, [
                        _createTextVNode(" Points "),
                        _createElementVNode("select", {
                          class: "nge-smo-point-size-pick",
                          value: $setup.nearestCutSize($setup.cutPointSize),
                          onChange: $setup.onCutPointSizePick
                        }, [
                          (_openBlock(), _createElementBlock(_Fragment, null, _renderList($setup.CUT_POINT_SIZES, (s) => {
                            return _createElementVNode("option", {
                              key: s.v,
                              value: s.v
                            }, _toDisplayString(s.label), 9 /* TEXT, PROPS */, _hoisted_33)
                          }), 64 /* STABLE_FRAGMENT */))
                        ], 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_32)
                      ]),
                      _createElementVNode("label", {
                        class: "nge-smo-auto-submit nge-smo-keep-open",
                        title: "Keep cut mode open after a cut, ready for the next one. Esc or C closes it. Off, cut mode closes after each cut.",
                        onClick: _withModifiers($setup.toggleKeepCutOpen, ["prevent"])
                      }, [
                        _createElementVNode("span", {
                          class: _normalizeClass(["nge-smo-checkbox", { checked: $setup.store.keepCutOpen }])
                        }, _toDisplayString($setup.store.keepCutOpen ? '☑' : '☐'), 3 /* TEXT, CLASS */),
                        _createTextVNode(" Keep open after a cut ")
                      ], 8 /* PROPS */, _hoisted_34)
                    ], 64 /* STABLE_FRAGMENT */))
                  : ($setup.isMerge)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                        _createCommentVNode(" MERGE MODE "),
                        _hoisted_35,
                        _createCommentVNode(" Progress sits by the badge, where the eye already is (Amy). "),
                        ($setup.isSubmitting)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_36, _hoisted_38))
                          : _createCommentVNode("v-if", true),
                        _createCommentVNode(" The merge controls sit together on the left, as the cut ones do\n               (Ames, 2026-10-08), with Clear among them; the hint takes the\n               rest of the bar. "),
                        (!$setup.isSubmitting)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                              _createElementVNode("button", {
                                class: _normalizeClass(["nge-smo-action-btn submit-btn", { 'is-ready': $setup.mergeReady }]),
                                onClick: _cache[6] || (_cache[6] = $event => ($setup.submitTool('merge'))),
                                title: "Submit the merge (or press Enter)"
                              }, "Submit merge", 2 /* CLASS */),
                              _createElementVNode("button", {
                                class: "nge-smo-action-btn clear-btn",
                                onClick: $setup.clearMerges,
                                title: "Clear every queued merge"
                              }, "Clear"),
                              _createElementVNode("button", {
                                class: "nge-smo-action-btn cancel-btn",
                                onClick: $setup.cancelTool,
                                title: "Exit merge mode"
                              }, [
                                (!$setup.isTouchRef)
                                  ? (_openBlock(), _createElementBlock("kbd", _hoisted_40, "Esc"))
                                  : _createCommentVNode("v-if", true),
                                _createTextVNode(" Cancel")
                              ]),
                              _createElementVNode("label", {
                                class: "nge-smo-auto-submit",
                                title: "Auto-submit merges when both points are placed",
                                onClick: _withModifiers($setup.toggleAutoSubmit, ["prevent"])
                              }, [
                                _createElementVNode("span", {
                                  class: _normalizeClass(["nge-smo-checkbox", { checked: $setup.store.autoSubmit }])
                                }, _toDisplayString($setup.store.autoSubmit ? '☑' : '☐'), 3 /* TEXT, CLASS */),
                                _createTextVNode(" auto-submit ")
                              ], 8 /* PROPS */, _hoisted_41),
                              (!$setup.isTouchRef)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_42, [
                                    _hoisted_43,
                                    _createTextVNode(" Set points")
                                  ]))
                                : _createCommentVNode("v-if", true)
                            ]))
                          : _createCommentVNode("v-if", true),
                        ($setup.queueMin && $setup.hasMergeSegments)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 2,
                              class: "nge-smo-action-btn nge-smo-queue-chip",
                              onClick: _cache[7] || (_cache[7] = $event => ($setup.setQueueMin(false))),
                              title: "Show the Merge Queue"
                            }, [
                              _createTextVNode("Merge Queue (" + _toDisplayString($setup.store.mergeSegments.length) + ") ", 1 /* TEXT */),
                              _hoisted_44
                            ]))
                          : _createCommentVNode("v-if", true),
                        _createElementVNode("div", {
                          class: _normalizeClass(["nge-smo-hint nge-smo-hint--left merge-hint", { 'error-hint': $setup.hasInlineResult && $setup.resultIsError }])
                        }, _toDisplayString($setup.contextHint), 3 /* TEXT, CLASS */)
                      ], 64 /* STABLE_FRAGMENT */))
                    : _createCommentVNode("v-if", true)
            ], 2 /* CLASS */))
          : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    }),
    _createCommentVNode(" Merge segment queue (vertical list, left side) "),
    _createVNode(_Transition, { name: "merge-list-fade" }, {
      default: _withCtx(() => [
        ($setup.isMerge && $setup.hasMergeSegments && !$setup.isPendingClose && !$setup.queueMin)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              ref: "queueEl",
              class: "nge-smo-merge-panel",
              style: _normalizeStyle($setup.queueStyle)
            }, [
              _createElementVNode("div", {
                class: "nge-smo-merge-panel-header",
                title: "Drag to move. Double click to put it back.",
                onMousedown: $setup.startQueueDrag,
                onDblclick: $setup.resetQueuePlace
              }, [
                _createTextVNode(" Merge Queue (" + _toDisplayString($setup.store.mergeSegments.length) + ") ", 1 /* TEXT */),
                _hoisted_45,
                _createElementVNode("button", {
                  class: "nge-smo-merge-min",
                  onMousedown: _cache[8] || (_cache[8] = _withModifiers(() => {}, ["stop"])),
                  onDblclick: _cache[9] || (_cache[9] = _withModifiers(() => {}, ["stop"])),
                  onClick: _cache[10] || (_cache[10] = _withModifiers($event => ($setup.setQueueMin(true)), ["stop"])),
                  title: "Minimize to the Merge Mode bar",
                  "aria-label": "Minimize the Merge Queue"
                }, "–", 32 /* HYDRATE_EVENTS */)
              ], 32 /* HYDRATE_EVENTS */),
              _createElementVNode("div", _hoisted_46, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.store.mergeSegments, (pair, i) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: i,
                    class: "nge-smo-merge-row"
                  }, [
                    _createElementVNode("span", _hoisted_47, _toDisplayString(i + 1) + ".", 1 /* TEXT */),
                    _createElementVNode("span", {
                      class: "nge-smo-seg-id nge-smo-seg-id--hover nge-smo-seg-id--colored",
                      style: _normalizeStyle($setup.segChipStyle(pair[0])),
                      title: "Hover to light this segment up in the views. Right click to go to it.",
                      onMouseenter: $event => ($setup.hoverSegment(pair[0])),
                      onMouseleave: _cache[11] || (_cache[11] = $event => ($setup.hoverSegment(null))),
                      onContextmenu: _withModifiers($event => ($setup.jumpToSegment(pair[0])), ["prevent"])
                    }, _toDisplayString(pair[0]), 45 /* TEXT, STYLE, PROPS, HYDRATE_EVENTS */, _hoisted_48),
                    (pair[1])
                      ? (_openBlock(), _createElementBlock("span", _hoisted_49, "⇄"))
                      : _createCommentVNode("v-if", true),
                    (pair[1])
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 1,
                          class: "nge-smo-seg-id nge-smo-seg-id--hover nge-smo-seg-id--colored",
                          style: _normalizeStyle($setup.segChipStyle(pair[1])),
                          title: "Hover to light this segment up in the views. Right click to go to it.",
                          onMouseenter: $event => ($setup.hoverSegment(pair[1])),
                          onMouseleave: _cache[12] || (_cache[12] = $event => ($setup.hoverSegment(null))),
                          onContextmenu: _withModifiers($event => ($setup.jumpToSegment(pair[1])), ["prevent"])
                        }, _toDisplayString(pair[1]), 45 /* TEXT, STYLE, PROPS, HYDRATE_EVENTS */, _hoisted_50))
                      : _createCommentVNode("v-if", true),
                    ($setup.rowStatus(i))
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 2,
                          class: _normalizeClass(["nge-smo-merge-status", 'nge-smo-merge-status--' + $setup.rowStatus(i)])
                        }, _toDisplayString($setup.rowStatus(i)), 3 /* TEXT, CLASS */))
                      : _createCommentVNode("v-if", true),
                    ($setup.rowRemovable(i))
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 3,
                          class: "nge-smo-merge-remove",
                          onClick: _withModifiers($event => ($setup.store.removeMergeSegment(i)), ["stop"]),
                          title: "Remove this merge pair"
                        }, "×", 8 /* PROPS */, _hoisted_51))
                      : _createCommentVNode("v-if", true),
                    _createCommentVNode(" why it failed, in the server's words, on a line of its own "),
                    ($setup.rowWhy(i))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_52, _toDisplayString($setup.rowWhy(i)), 1 /* TEXT */))
                      : _createCommentVNode("v-if", true)
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              ])
            ], 4 /* STYLE */))
          : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    }),
    _createCommentVNode(" Holographic result flash (shows below bar for inline results during merge) "),
    _createVNode(_Transition, { name: "flash-pop" }, {
      default: _withCtx(() => [
        ($setup.hasInlineResult)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["nge-smo-result-flash", { success: $setup.resultIsSuccess, error: $setup.resultIsError }])
            }, [
              _createElementVNode("span", _hoisted_53, _toDisplayString($setup.resultIsSuccess ? '✓' : '✗'), 1 /* TEXT */),
              _createElementVNode("div", _hoisted_54, [
                _createElementVNode("span", _hoisted_55, _toDisplayString($setup.store.resultText), 1 /* TEXT */),
                ($setup.resultIsError)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                      _hoisted_57,
                      _createElementVNode("button", {
                        class: "nge-smo-result-ask",
                        onClick: _withModifiers($setup.askGuideAboutError, ["stop"])
                      }, "✦ Ask the AI guide what this means", 8 /* PROPS */, _hoisted_58)
                    ]))
                  : _createCommentVNode("v-if", true)
              ]),
              ($setup.resultIsError)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "nge-smo-result-close",
                    onClick: _cache[13] || (_cache[13] = _withModifiers($event => ($setup.store.dismissResult()), ["stop"])),
                    title: "Dismiss",
                    "aria-label": "Dismiss"
                  }, "×"))
                : _createCommentVNode("v-if", true)
            ], 2 /* CLASS */))
          : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    })
  ]))
}